@if (errorDetailsVisible) {
  <app-error-message [errorMessage]="error"></app-error-message>
}
@if (error) {
  <div class="out-of-order-container" (click)="toggleErrorDetails()">
    <div class="out-of-order">
      <div>TEMPORARILY</div>
      <div>OUT OF</div>
      <div>SERVICE</div>
    </div>
  </div>
}
@if (!loaded && !error) {
  <app-spinner size="3x"></app-spinner>
}
<div id="tableauViz"></div>
